export const labelSymbol = Symbol('enum labels');

interface WithLabelMap<T> {
    [labelSymbol]?: Map<T, string>
};

type AnEnum<T> = any; //Record<number, string> & Record<string, T> & WithLabelMap<T> & T;

function parseCaps(name: string): string {
    return name.replace(/(?<=[a-z])([A-Z0-9])|(?<!^)([A-Z0-9])(?=[a-z])/g, ' $1$2');
}

export function getValues<T>(enumObj: AnEnum<T>): T[] {
    return <T[]>Object.values(enumObj).filter(n => typeof n !== 'string');
}

export function setLabels<T>(enumObj: AnEnum<T>, hardcoded: [T, string][] = []): void {
    const vals = getValues<T>(enumObj);

    const m = new Map<T, string>();

    for (const v of vals)
        m.set(v, hardcoded.find(h => h[0] === v)?.[1] ?? parseCaps(enumObj[<any> v]));

    enumObj[labelSymbol] = m;
}

export function getLabel<T>(enumObj: AnEnum<T>, val: T): string {
    return enumObj[labelSymbol]?.get(val) ?? '';
}

export function getLabels<T>(enumObj: AnEnum<T>): [ T, string ][] {
    return getValues<T>(enumObj).map(v => ([v, getLabel(enumObj, v)]));
}
